"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullifyMagicAbilityHandler = exports.NullifyMagicActorAbilityFactory = exports.NullifyMagicAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class NullifyMagicAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.NullifyMagic;
        this.__typeName = "NullifyMagic";
    }
}
exports.NullifyMagicAbilityArgs = NullifyMagicAbilityArgs;
let NullifyMagicActorAbilityFactory = class NullifyMagicActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("NullifyMagic", "AllAllies", 3);
    }
};
NullifyMagicActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("NullifyMagic")
], NullifyMagicActorAbilityFactory);
exports.NullifyMagicActorAbilityFactory = NullifyMagicActorAbilityFactory;
let NullifyMagicAbilityHandler = class NullifyMagicAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.removeDebuffs({
                    sequence,
                    removerId: ability.invokerId,
                    targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                        .map(allyId => ({
                        targetId: allyId,
                        includeSupernatural: false,
                        onDebuffsRemoved: sequence => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "feet", "behind"), "DarkMagicCircle"))
                    }))
                });
            }
        });
    }
};
NullifyMagicAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.NullifyMagic)
], NullifyMagicAbilityHandler);
exports.NullifyMagicAbilityHandler = NullifyMagicAbilityHandler;
